<template>
  <v-card class="elevation-12" min-height="300" width="800">
    <v-toolbar flat>
      <v-col class="d-flex justify-space-around">
        <v-toolbar-title>
          <h3 style="font-size: 24px;">Registro de nuevo usuario</h3>
        </v-toolbar-title>
      </v-col>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-text-field
              label="Nombres y apellidos"
              name="nombres"
              type="text"
              v-model="usuario.nombres"
              :disabled="loading"
              :error-messages="error.nombres"
              @keyup.enter="registro"
              @change="error.nombres = ''"
              @input="
                v => {
                  usuario.nombres = v.toUpperCase();
                }
              "
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-select
              :disabled="loading"
              :items="tipos_documento"
              no-data-text="Cargando..."
              item-text="descripcion"
              item-value="codigo"
              label="Tipo de Documento"
              return-object
              v-model="usuario.tipo_documento"
              @change="validarLongitud()"
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              label="Documento"
              name="documento"
              type="text"
              v-model="usuario.documento"
              :disabled="loading || usuario.tipo_documento == null"
              :error-messages="error.documento"
              @keyup.enter="registro"
              @change="error.documento = ''"
              :maxlength="
                usuario.tipo_documento != null &&
                usuario.tipo_documento.longitud != null
                  ? usuario.tipo_documento.longitud
                  : 255
              "
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              label="Teléfono"
              name="telefono"
              type="text"
              v-model="usuario.telefono"
              :disabled="loading"
              :error-messages="error.telefono"
              @keyup.enter="registro"
              @change="error.telefono = ''"
              @input="
                v => {
                  usuario.telefono = v.toUpperCase();
                }
              "
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              label="Correo"
              name="correo"
              type="text"
              v-model="usuario.correo"
              :disabled="loading"
              :error-messages="error.correo"
              @keyup.enter="registro"
              @change="error.correo = ''"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              label="Placa vehículo"
              name="placa"
              type="text"
              v-model="usuario.placa_vehiculo"
              :disabled="loading"
              :error-messages="error.placa_vehiculo"
              @keyup.enter="registro"
              @change="error.placa_vehiculo = ''"
              @input="
                v => {
                  usuario.placa_vehiculo = v.toUpperCase();
                }
              "
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-menu v-model="menuVIN" :close-on-content-click="false" offset-x>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Serie vehículo / VIN / chasís"
                  name="serie"
                  type="text"
                  v-model="usuario.serie_vehiculo"
                  :disabled="loading"
                  :error-messages="error.serie_vehiculo"
                  @keyup.enter="registro"
                  @change="error.serie_vehiculo = ''"
                  append-icon="mdi-help-circle"
                  @click:append="menuVIN = true"
                  v-on="on"
                  v-bind="attrs"
                  @input="
                    v => {
                      usuario.serie_vehiculo = v.toUpperCase();
                    }
                  "
                  :maxlength="17"
                  dense
                ></v-text-field>
              </template>
              <v-card height="300px" style="padding: 5px;">
                <img
                  :src="imagenVIN"
                  style="max-width:100%; max-height:100%; margin: auto; display: block;"
                />
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              label="Usuario"
              name="username"
              type="text"
              v-model="usuario.username"
              :disabled="loading"
              :error-messages="error.username"
              @keyup.enter="registro"
              @change="error.username = ''"
              @input="
                v => {
                  usuario.username = v.toUpperCase();
                }
              "
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-text-field
              :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
              :disabled="loading"
              :error-messages="error.password"
              :type="show_password ? 'text' : 'password'"
              @change="error.password = ''"
              @click:append="show_password = !show_password"
              @keyup.enter="registro"
              label="Contraseña"
              maxlength="12"
              name="Contraseña"
              v-model="usuario.password"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-checkbox
              v-model="chkTerminos"
              dense
              hide-details
              class="ma-0"
              :error="errTerminos"
              @change="
                v => {
                  if (chkTerminos) {
                    errTerminos = false;
                  }
                }
              "
            >
              <template v-slot:label>
                <a
                  :target="etqTerminos == '' ? '_self' : '_blank'"
                  :href="etqTerminos"
                  @click.stop
                >
                  Términos y condiciones
                </a>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-checkbox
              v-model="chkProteccion"
              dense
              hide-details
              class="ma-0"
              :error="errProteccion"
              @change="
                v => {
                  if (chkProteccion) {
                    errProteccion = false;
                  }
                }
              "
            >
              <template v-slot:label>
                <a
                  :target="etqProteccion == '' ? '_self' : '_blank'"
                  :href="etqProteccion"
                  @click.stop
                >
                  Protección de datos personales
                </a>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="accent" @click="regreso" :disabled="loading">
        Regresar
      </v-btn>
      <span style="width: 100px;"></span>
      <v-btn color="primary" @click="registro" :disabled="loading">
        Registrar
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
export default {
  name: "Registro",
  data() {
    return {
      tipos_documento: [],
      usuario: {
        nombres: "",
        telefono: "",
        tipo_documento: null,
        documento: "",
        correo: "",
        serie_vehiculo: "",
        username: "",
        password: "",
        placa_vehiculo: ""
      },
      error: {
        nombres: "",
        telefono: "",
        tipo_documento: "",
        documento: "",
        correo: "",
        serie_vehiculo: "",
        username: "",
        password: "",
        placa_vehiculo: ""
      },
      loading: false,
      show_password: false,
      chkTerminos: false,
      chkProteccion: false,
      errTerminos: false,
      errProteccion: false,
      etqTerminos:
        process.env.VUE_APP_BASE_PATH + `/api/config/GetDocumento?id=terminos`,
      etqProteccion:
        process.env.VUE_APP_BASE_PATH +
        `/api/config/GetDocumento?id=proteccion`,
      menuVIN: false,
      imagenVIN: ""
    };
  },
  methods: {
    ...mapActions(["setToken", "showAlerta", "hideAlerta"]),
    validarLongitud(valor) {
      if (this.usuario.tipo_documento != null) {
        if (
          this.usuario.tipo_documento.longitud != null &&
          this.usuario.documento.length >= this.usuario.tipo_documento.longitud
        ) {
          this.usuario.documento = this.usuario.documento.substr(
            0,
            this.usuario.tipo_documento.longitud
          );
        }
      }
    },
    async registro() {
      if (!this.chkTerminos || !this.chkProteccion) {
        if (!this.chkTerminos) {
          this.errTerminos = true;
        }

        if (!this.chkProteccion) {
          this.errProteccion = true;
        }

        return;
      }

      const params = {
        nombres: this.usuario.nombres,
        telefono: this.usuario.telefono,
        tipo_documento: this.usuario.tipo_documento
          ? this.usuario.tipo_documento.codigo
          : null,
        documento: this.usuario.documento,
        correo: this.usuario.correo,
        serie_vehiculo: this.usuario.serie_vehiculo,
        username: this.usuario.username,
        password: this.usuario.password,
        placa_vehiculo: this.usuario.placa_vehiculo
      };

      let respuesta;

      for (const key in params) {
        this.error[key] = "";
      }

      try {
        this.loading = true;
        respuesta = await axios.post(
          process.env.VUE_APP_BASE_PATH + "/api/usuario/registrar",
          params
        );
      } catch (error) {
        this.showAlerta({
          mensaje: error.response.data.error_description,
          tipo: 3
        });

        return;
      } finally {
        this.loading = false;
      }
      // console.log(respuesta);
      if (respuesta.data.tipo != 0) {
        if (respuesta.data.codigo == "VALIDACIONES") {
          for (const key in params) {
            this.error[key] = respuesta.data.data[key];
          }
        } else {
          this.showAlerta({ mensaje: respuesta.data.mensaje, tipo: 3 });
        }
        return;
      }

      this.showAlerta({
        mensaje: respuesta.data.mensaje,
        tipo: 0,
        tiempo: 10000
      });

      this.$router.push("Login");
    },
    async listarTiposDocumento() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/config/ListarTiposDocumento`
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      this.tipos_documento = respuesta.data;
    },
    async loadParametros() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/config/ListarParametrosRegistro`
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      respuesta.data.forEach(x => {
        switch (x.codigo) {
          case "LINK_TERM_Y_COND":
            this.etqTerminos = x.valor;
            break;
          case "LINK_PROTEC_DATOS":
            this.etqProteccion = x.valor;
            break;
        }
      });
    },
    async loadCacheImagen() {
      let respuesta;
      try {
        respuesta = await axios.get(
          process.env.VUE_APP_BASE_PATH + `/api/config/GetImagen?id=tarjeta`,
          { responseType: "arraybuffer" }
        );
      } catch (error) {
        if (error.response.status == 400) {
          this.showAlerta2({
            mensaje: error.response.data.error_description,
            tipo: 3
          });
        } else {
          this.salir();
        }
        return;
      }

      const image = btoa(
        new Uint8Array(respuesta.data).reduce(
          (acc, byte) => acc + String.fromCharCode(byte),
          ""
        )
      );
      this.imagenVIN = `data:image/png;base64,${image}`;
    },
    regreso() {
      this.hideAlerta();
      this.$router.push("Login");
    }
  },
  created() {
    this.loadCacheImagen();
    this.listarTiposDocumento();
    // this.loadParametros();
  }
};
</script>

<style scoped>
h3 {
  font-weight: 500;
}
</style>
